import { useEffect, useState } from "react";
import { getCertifPopup } from '../../../../../../../api/repositories'
import { useDispatch } from 'react-redux'

// for translate
import { useTranslation } from 'react-i18next';

const useActions = (setModalCertificate) => {
    const [ loadingFetchPopupCertif, setLoadingFetchPopupCertif ] = useState(true);
    const [ listCertifPopup, setListCertifPopup ] = useState([])

    const fetchListCertifPopup = async(jid,cid,mid) => {
        setLoadingFetchPopupCertif(true)
    
        try {
            const { data, status } = await getCertifPopup(jid,cid,mid)

            if(status === 200){
                setListCertifPopup(data[0].file_name)
            }
            
        } catch (error) {
            console.log(error.message)
            setListCertifPopup([])
        } finally {
            setLoadingFetchPopupCertif(false);
            setModalCertificate(true)
        }
    }

    return{
        loadingFetchPopupCertif,
        listCertifPopup,
        fetchListCertifPopup
    }
}

export default useActions